<template>
  <div id="app">
    <div class="common-layout">
      <el-container>
        <el-header v-if="showChrome" class="custom-header" style="height: 75px">
          <HeaderView :isWideScreen="isMobileScreen" />
        </el-header>
        <el-main style="padding: 0%;">
          <router-view :isWideScreen="isMobileScreen"> </router-view>
        </el-main>
        <el-footer v-if="showChrome" style="padding: 0%;">
          <FooterView :isWideScreen="isMobileScreen"/>
        </el-footer>
      </el-container>
    </div>
  </div>
</template>

<script>
import { Container, Header, Main, Footer } from "element-ui";
import HeaderView from "./components/HeaderView.vue";
import FooterView from "./components/FooterView.vue";

export default {
  name: "App",
  components: {
    "el-container": Container,
    "el-header": Header,
    "el-main": Main,
    "el-footer": Footer,
    HeaderView,
    FooterView,
  },
  data() {
    return {
      isMobileScreen: false,
    };
  },
  computed: {
    // 遍历所有匹配到的路由层级（父 + 子），任意一层带 hideChrome 就隐藏全局页头/页脚。
    // 不能用 this.$route.meta.hideChrome —— 嵌套子路由（如 /admin/dashboard）的 meta
    // 不会自动带上父路由的 hideChrome，必须像登录守卫那样用 matched.some 检查。
    showChrome() {
      return !this.$route.matched.some(
        (r) => r.meta && r.meta.hideChrome
      );
    },
  },
  watch: {
    $route(to) {
      document.title =
        to.meta && to.meta.title ? to.meta.title : this.$t("title");
    },
  },
  mounted() {
    const title = this.$t("title");
    document.title = title;

    window.addEventListener("resize", this.handleResize);
    this.checkScreenWidth()
    //this.startHacking()
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      this.checkScreenWidth();
    },
    checkScreenWidth() {
      // 获取窗口宽度
      const screenWidth = window.innerWidth;
      // 根据窗口宽度设置 isWideScreen 变量
      this.isMobileScreen = screenWidth > 828; // 768px 是示例阈值，你可以根据实际情况调整
    },
    

    startHacking() {
      this.$notify({
        title: "It works!",
        type: "success",
        message:
          "We've laid the ground work for you. It's time for you to build something epic!",
        duration: 5000,
      });
    },
  },
};
</script>

<style>
/* #app {
  font-family: Helvetica, sans-serif;
  text-align: center;
} */

body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0; /* 移除上部间距 */
  padding: 0; /* 移除左右间距 */
  /* margin-top: 60px; */
}
.common-layout {
  margin: 0; /* 移除上部间距 */
  padding: 0; /* 移除左右间距 */
}
.custom-header {
  padding-left: 0 !important; /* 去掉左侧 padding */
  padding-right: 0 !important; /* 去掉右侧 padding */
}
</style>



// WEBPACK FOOTER //
// src/App.vue